import { useCallback } from "react"
import invariant from "./invariant"
import { UseTranslationParams, TranslateFunc } from "./types"

export default function useTranslation({
  locales,
  keyPrefix,
}: UseTranslationParams) {

  const t: TranslateFunc = useCallback(
    (callBackKey, interpolations) => {
      const paths = [...(keyPrefix?.split(".") ?? []), ...callBackKey.split(".")]

      if (/test/.test(process.env.NODE_ENV as string)) {
        return `${process.env.NEXT_PUBLIC_LOCALE}:${paths.join(".")}`
      }

      /**
       * TODO:
       * Replace 'any' type on result
       */
      let result: any = locales

      paths.forEach((path) => {
        result = result[path]
        invariant(
          typeof result === "undefined",
          `i18n: translation missing for "${process.env.NEXT_PUBLIC_LOCALE}:${paths.join(".")}"`
        )
      })

      /*
       * Replaces {{key}} with the value
       * of the corresponding property
       * in interpolations object
       */
      if (interpolations) {
        Object.entries(interpolations).forEach(([key, value]) => {
          const re = new RegExp(`{{${key}}}`)
          result = (result as string).replace(re, value)
        })
      }

      return result
    },
    [keyPrefix, locales]
  )

  return [t]
}
